/**
 * Backoffice — Demandes de devis (leads du site public).
 *
 * Repointe l'écran `/app/cms/quote-requests` du client CMS (jamais construit)
 * vers le domaine Go `quoterequests` exposé sous `/v1/quote-requests`.
 * Contrat : voir docs/modules/M01-devis/adr/ADR-001-quote-requests-lead-intake.md
 *
 * Le DTO de réponse backend matche exactement la forme historique du type
 * `QuoteRequest` afin de réutiliser l'écran sans refonte.
 */

import { apiFetch } from '@/api/client'

export interface QuoteRequest {
  id: string
  origin: string
  destination: string
  cargo_type: string
  weight_kg?: number
  volume_m3?: number
  transport_mode: string
  contact_name: string
  contact_email: string
  contact_phone?: string
  company_name?: string
  message?: string
  status: 'new' | 'contacted' | 'converted' | 'closed'
  created_at: string
}

/** Enveloppe liste — forme attendue telle quelle par l'écran (pas de `.data`). */
interface QuoteRequestListResponse {
  quote_requests: QuoteRequest[]
  next_cursor?: string
}

interface Envelope<T> {
  data: T
}

export function listQuoteRequests(status?: string): Promise<QuoteRequestListResponse> {
  const params = new URLSearchParams()
  if (status) params.set('status', status)
  const qs = params.toString()
  return apiFetch<QuoteRequestListResponse>(`/v1/quote-requests${qs ? `?${qs}` : ''}`)
}

export function getQuoteRequest(id: string): Promise<QuoteRequest> {
  return apiFetch<Envelope<QuoteRequest>>(`/v1/quote-requests/${id}`).then((r) => r.data)
}

export function updateQuoteStatus(
  id: string,
  status: QuoteRequest['status'],
): Promise<QuoteRequest> {
  return apiFetch<Envelope<QuoteRequest>>(`/v1/quote-requests/${id}/status`, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  }).then((r) => r.data)
}
